export interface ExperienceType {
    id: number;
    label: string;
}

export class ExperienceTypeModel {
    public id: number;
    public label: string;

    constructor({
                    id,
                    label,
                }: ExperienceType) {
        this.id = id;
        this.label = label;
    }
}
